// extracted by mini-css-extract-plugin
export default {"card":"Account_card__JMgpO","section":"Account_section__YAdoU"};